import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Image } from 'foundations-components/transitional/components/Image';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import I18n from 'I18n';
import OneClickSyncButton from '../OneClickSync/OneClickSyncButton';
import { getIsEnglishLangUser } from '../../utils/langUtils';
// @ts-expect-error png image
import googleOauthPermissionWarningSrc from 'bender-url!../../../images/google-oauth-permission-warning-en.png';
import { DataSyncOptionApp } from '../../constants/types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GoogleDataSyncContactPermissionsWarningDialog = ({
  rootNode,
  onClose,
  onSyncClick,
  onAuthenticationSuccess,
  onAuthenticationError
}) => {
  const isEnglishLangUser = getIsEnglishLangUser();
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "google-data-sync-contact-permissions-warning-dialog",
    use: "conversational",
    rootNode: rootNode,
    width: 600,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "growthDataModal.oneClickSync.google-contacts-permission-warning.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "600",
        children: isEnglishLangUser ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "growthDataModal.oneClickSync.google-contacts-permission-warning.screenshot-description"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "growthDataModal.oneClickSync.google-contacts-permission-warning.description"
        })
      }), isEnglishLangUser && /*#__PURE__*/_jsx(View, {
        boxShadow: "400",
        children: /*#__PURE__*/_jsx(Image, {
          alt: I18n.text('growthDataModal.oneClickSync.google-contacts-permission-warning.screenshot-alt'),
          src: googleOauthPermissionWarningSrc
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(OneClickSyncButton, {
        app: DataSyncOptionApp.Gmail,
        buttonType: "loading",
        "data-test-id": "google-data-sync-contact-permissions-warning-dialog-cta",
        onAuthenticationSuccess: onAuthenticationSuccess,
        onAuthenticationError: onAuthenticationError,
        onClick: onSyncClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "growthDataModal.oneClickSync.google-contacts-permission-warning.cta"
        })
      })
    })]
  });
};
export default GoogleDataSyncContactPermissionsWarningDialog;